import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { cn } from '../utils/cn';

interface ButtonProps {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string
};

const Button: React.FC<ButtonProps> = ({label, onClick, disabled = false, loading = false, className}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={cn([`bg-gradient-to-b from-[#8C84FF] to-[#6158E0] flex items-center justify-center py-3 rounded-3xl cursor-pointer focus:outline-none w-full ${disabled || loading ? 'opacity-80 cursor-not-allowed' : ''}`, className])}
      aria-label={label}
      aria-busy={loading}
    >
      <div className="flex items-center gap-2">
        {loading && <Spin indicator={<LoadingOutlined className="text-white" spin />} />}
        <p className="text-base font-medium text-white">{label}</p>
      </div>
    </button>
  );
};

export default Button;
